import { createSvgIcon } from 'common/theme/utils';

import Error from './Error.svg?react';
import Success from './Success.svg?react';

export const SuccessIcon = createSvgIcon(Success, 'Success');
export const ErrorIcon = createSvgIcon(Error, 'Error');
